import React, { lazy } from 'react';
import ProtectedRoute from '@/router/components/ProtectedRoute';
import { ROUTES } from '@/constants/routes';

// Lazy loaded components
const AdminPage = lazy(() => import('@/pages/admin'));

/**
 * Admin routes configuration
 */
export const adminRoutes = {
  path: ROUTES.ADMIN,
  element: <ProtectedRoute component={AdminPage} />,
};
